import React, { useState, useEffect } from "react";
import { apollo_useStyles, getModalStyle } from "../../atom/Apollo_styles";
import { ApolloMessage } from "../../atom/Apollo_Mesasge";
import { ApolloAxios } from "../../atom/Apollo_ApiRequest3";

import Grid from "@material-ui/core/Grid";

import Modal from "@material-ui/core/Modal";
import Card from "@material-ui/core/Card/Card";
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography";

import classNames from "classnames";

import {
  MasterModalProps,
  MasterReference,
} from "./MasterModel"

import {
  apollo_product_master_accouts_path,
  apollo_industory_master_products_path,
  apollo_billing_resource_master_accountgroups_path,
} from "../../atom/Apollo_links"

// エラーメッセージ
const ERROR_MESSGAE = [
  "データの取得に失敗しました"
];

const ApolloMasterReferenceModal: React.FC<MasterModalProps> = (props) => {
  const { data, setmsg } = React.useContext(ApolloMessage);
  const [masterReference, setMasterReference] = useState<MasterReference[]>([])

  const classes = apollo_useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const flameClass = classNames(classes.root, classes.flame);

  // API取得
  useEffect(() => {
    // リクエスト前の値をクリア
    setMasterReference([])

    // AccountIDが設定されていない場合は、リクエストを送らない
    if (props.id !== 0) {
      var url = "";
      switch (props.index) {
        case 1:
          url = apollo_product_master_accouts_path
          break;
        case 2:
          url = apollo_industory_master_products_path
          break;
        default:
          url = apollo_billing_resource_master_accountgroups_path
      }
      url += "/" + props.id;
      ApolloAxios.get(url).then(response => {
				if (response.data.resultCode === 0) {
          // マスタ関連情報を設定
          setMasterReference(response.data.result)
        } else {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: ERROR_MESSGAE[0]
            }
          });
          return;
        }
      }).catch(err => {
        // エラー時、前の値が表示されないようにマスタ関連情報を空配列で設定
        setMasterReference([])
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: ERROR_MESSGAE[0]
          }
        });
      })
    }
  }, [props.id]);

  return (
    <Modal open={props.open} onClose={() => props.setOpen(false)}>
      <div style={modalStyle} className={classes.accountpaper}>
        <Card className={classes.root} square variant="outlined">
          <Box m={3} className={flameClass}>
            {masterReference?.map((masterReference, index) => (
              <Grid container spacing={3} key={index}>
                <Grid item xs={2}>
                  <Typography variant="subtitle1" gutterBottom component="div">{masterReference.id}:</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="subtitle1" gutterBottom component="div">{masterReference.name}</Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Card>
      </div>
    </Modal>
  )
}
export default ApolloMasterReferenceModal;
